import { CommonFunctionUtil } from '../../../../common/FlyAPIUtil/common-util-factory'

class SimpleStore {
  constructor(value = false) {
    this.value = value
    this.subscribers = new Map()
  }

  subscribe(subscriber) {
    const subscriberKey = CommonFunctionUtil.generateGUID()
    this.subscribers.set(subscriberKey, subscriber)
    return subscriberKey
  }

  unsubscribe(subscriberKey) {
    this.subscribers.delete(subscriberKey)
  }

  dispatch(simpleValue) {
    this.value = simpleValue
    this.subscribers.forEach(method => {
      method(this.value)
    })
  }

  get() {
    return this.value
  }

  static merge(publishers, mergedSubscriber) {
    const subscriptionsFired = new Map()
    const subscriptionKeys = publishers.map(pub => {
      return pub.subscribe(val => {
        subscriptionsFired.set(pub, val)

        if (subscriptionsFired.size === publishers.length) {
          mergedSubscriber(...subscriptionsFired.values())
        }
      })
    })

    return {
      unsubscribe: () =>
        publishers.forEach((pub, index) =>
          pub.unsubscribe(subscriptionKeys[index])
        )
    }
  }
}

const showErrorScreen = new SimpleStore()
const baggageFeeStore = new SimpleStore()
const baggageFeesListingsStore = new SimpleStore()
const showSearchRefreshOverlay = new SimpleStore()
const showLoadingScreen = new SimpleStore()
const showLoadingScreenServerSide = new SimpleStore()
const showTooltip = new SimpleStore()
const showNyop = new SimpleStore()
const reloadExpressDeals = new SimpleStore()
const sliceSelectionTrigger = new SimpleStore()
const showBpgOverlay = new SimpleStore()
const sortSelect = new SimpleStore({
  name: 'price',
  textValue: 'PRICE'
})
const progressBar = new SimpleStore()
const showListing = new SimpleStore()
const showFilterBar = new SimpleStore()
const showDesktopFilterSideBar = new SimpleStore()
const showTripSummaryHeader = new SimpleStore()
const whenSearchTableLoaded = new SimpleStore()
const filterTimer = new SimpleStore()
const listingLoadingStatus = new SimpleStore()
const stickySearchHeader = new SimpleStore()
const currentSliceChanged = new SimpleStore()
const showReturningFlights = new SimpleStore()
const showDepartingFlights = new SimpleStore()
const reactFilterStateChange = new SimpleStore({})

export {
  SimpleStore,
  showErrorScreen,
  baggageFeeStore,
  baggageFeesListingsStore,
  showSearchRefreshOverlay,
  showLoadingScreen,
  showLoadingScreenServerSide,
  showTooltip,
  showNyop,
  reloadExpressDeals,
  sliceSelectionTrigger,
  showBpgOverlay,
  sortSelect,
  progressBar,
  showListing,
  showFilterBar,
  showDesktopFilterSideBar,
  showTripSummaryHeader,
  whenSearchTableLoaded,
  filterTimer,
  listingLoadingStatus,
  stickySearchHeader,
  currentSliceChanged,
  showReturningFlights,
  showDepartingFlights,
  reactFilterStateChange
}
